var _path, _path2, _path3, _path4, _path5, _path6, _mask, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruckLate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833496 0.833328H13.0557V11.9444H0.833496V0.833328Z",
    stroke: "#C43232",
    strokeWidth: 1.66667,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0557 4.16666H17.5001L20.8334 7.49999V11.9444H13.0557V4.16666Z",
    stroke: "#C43232",
    strokeWidth: 1.66667,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27789 16.3889C6.50519 16.3889 7.50011 15.394 7.50011 14.1667C7.50011 12.9394 6.50519 11.9444 5.27789 11.9444C4.05059 11.9444 3.05566 12.9394 3.05566 14.1667C3.05566 15.394 4.05059 16.3889 5.27789 16.3889Z",
    stroke: "#C43232",
    strokeWidth: 1.66667
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3887 16.3889C17.616 16.3889 18.6109 15.394 18.6109 14.1667C18.6109 12.9394 17.616 11.9444 16.3887 11.9444C15.1614 11.9444 14.1665 12.9394 14.1665 14.1667C14.1665 15.394 15.1614 16.3889 16.3887 16.3889Z",
    stroke: "#C43232",
    strokeWidth: 1.66667
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8335 2.61111L10.8335 9.61111H2.8335L6.8335 2.61111Z",
    stroke: "#C43232",
    strokeWidth: 1.45833,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8335 5.61111V7.1111",
    stroke: "#C43232",
    strokeWidth: 0.594652,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_117_451",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.8335 9.6111C7.38578 9.6111 7.8335 9.16338 7.8335 8.6111C7.8335 8.05881 7.38578 7.6111 6.8335 7.6111C6.28121 7.6111 5.8335 8.05881 5.8335 8.6111C5.8335 9.16338 6.28121 9.6111 6.8335 9.6111Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8335 9.6111C7.38578 9.6111 7.8335 9.16338 7.8335 8.6111C7.8335 8.05881 7.38578 7.6111 6.8335 7.6111C6.28121 7.6111 5.8335 8.05881 5.8335 8.6111C5.8335 9.16338 6.28121 9.6111 6.8335 9.6111Z",
    fill: "#C43232"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8335 8.6111H5.8335C5.8335 8.05881 6.28121 7.6111 6.8335 7.6111V9.6111V11.6111C8.49035 11.6111 9.8335 10.268 9.8335 8.6111H7.8335ZM6.8335 9.6111V7.6111C7.38578 7.6111 7.8335 8.05881 7.8335 8.6111H5.8335H3.8335C3.8335 10.268 5.17664 11.6111 6.8335 11.6111V9.6111ZM5.8335 8.6111H7.8335C7.8335 9.16338 7.38578 9.6111 6.8335 9.6111V7.6111V5.6111C5.17664 5.6111 3.8335 6.95424 3.8335 8.6111H5.8335ZM6.8335 7.6111V9.6111C6.28121 9.6111 5.8335 9.16338 5.8335 8.6111H7.8335H9.8335C9.8335 6.95424 8.49035 5.6111 6.8335 5.6111V7.6111Z",
    fill: "#C43232",
    mask: "url(#path-7-inside-1_117_451)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckLate);
export default __webpack_public_path__ + "static/media/truck_late.7778d7d1.svg";
export { ForwardRef as ReactComponent };